import React, { useState } from 'react';

import styles from '../assets/css/offers.module.css';
import LoginModal from '../Auth/LoginModal';
import BouncingDotsLoader from '../common/BouncingDotsLoader';
import { useAuthContext } from '../Auth/context';

import Modal from './Modal';
import Slices from './Slices';
import PopUp from '../common/PopUp';

const OfferCard = ({ mode = 'compact', error, ...props }) => {
  const { offer, createBooking, submitting, handleGuest } = props;
  const [showModal, setShowModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const { state:{loggedIn,logged}} = useAuthContext();

  const handleBookingClick = () => {
    if(loggedIn || logged){
      createBooking();
    }
    else{
      setShowLoginModal(true);
    }
  };

  return (
    <>
      <div className={mode === 'detailed' ? styles.modal_offer_details_container : styles.offer_card_container}>
        <Slices
          mode={mode}
          baggages={offer.baggage}
          slices={offer.slices}
          tripType={offer.tripType}
          onClick={() => setShowModal(mode !== 'detailed')}
        />

        <div className={styles.offer_card_price}>
          {/* {
            props.suggested && mode !== 'detailed' &&
            <div className={styles.suggested_offer}>
              <p>رحلة مقترحة</p>
            </div>
          } */}
          <div className={styles.offer_card_price_container}>
            <p>{offer.price.toLocaleString()} <sup className={styles.offer_card_currency}>{offer.currency}</sup></p>

          </div>
          <div>
            <button
              className="button"
              onClick={handleBookingClick}
            >احجز</button>
            {mode === 'compact' && <button
              onClick={() => setShowModal(true)}
              className="blank-button"
            >المزيد من التفاصيل</button>}
          </div >
        </div >
      </div >

      {
        loggedIn && submitting && <BouncingDotsLoader />
      }
      {
        loggedIn && error && <PopUp message={error}
        />
      }
      {
        showModal && <Modal
          offer={offer}
          onClose={() => setShowModal(false)}
          content={
            <OfferCard
              {...props}
              mode="detailed"
            />} />
      }

      {
        showLoginModal && <LoginModal
          onClose={() => setShowLoginModal(false)}
          params={{ offer }}
          handleBooking={createBooking}
          handleGuest={handleGuest}
          submitting={submitting}
          error={error}
        />
      }
    </>
  );
};

export default OfferCard;